module.exports = __webpack_public_path__ + "img/03.d5f1636c.jpg";